// import * as React from "react";
// import { styled } from "@mui/material/styles";
// import Stack from "@mui/material/Stack";
// import Stepper from "@mui/material/Stepper";
// import Step from "@mui/material/Step";
// import StepLabel from "@mui/material/StepLabel";
// import StepConnector, {
//   stepConnectorClasses,
// } from "@mui/material/StepConnector";
// import DomainVerificationIcon from "@mui/icons-material/DomainVerification";
// import UploadFileIcon from "@mui/icons-material/UploadFile";
// import DoneIcon from "@mui/icons-material/Done";

// const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
//   [`&.${stepConnectorClasses.alternativeLabel}`]: {
//     top: 22,
//   },
//   [`&.${stepConnectorClasses.active}`]: {
//     [`& .${stepConnectorClasses.line}`]: {
//       backgroundImage:
//         "linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)",
//     },
//   },
//   [`&.${stepConnectorClasses.completed}`]: {
//     [`& .${stepConnectorClasses.line}`]: {
//       backgroundImage:
//         "linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)",
//     },
//   },
//   [`& .${stepConnectorClasses.line}`]: {
//     height: 3,
//     border: 0,
//     backgroundColor: "#eaeaf0",
//     borderRadius: 1,
//     ...theme.applyStyles("dark", {
//       backgroundColor: theme.palette.grey[800],
//     }),
//   },
// }));

// const ColorlibStepIconRoot = styled("div")(({ theme }) => ({
//   backgroundColor: "#ccc",
//   zIndex: 1,
//   color: "#fff",
//   width: 50,
//   height: 50,
//   display: "flex",
//   borderRadius: "50%",
//   justifyContent: "center",
//   alignItems: "center",
//   ...theme.applyStyles("dark", {
//     backgroundColor: theme.palette.grey[700],
//   }),
//   variants: [
//     {
//       props: ({ ownerState }) => ownerState.active,
//       style: {
//         backgroundImage:
//           "linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)",
//         boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
//       },
//     },
//     {
//       props: ({ ownerState }) => ownerState.completed,
//       style: {
//         backgroundImage:
//           "linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)",
//       },
//     },
//   ],
// }));

// function ColorlibStepIcon(props) {
//   const { active, completed, className } = props;

//   const icons = {
//     1: <DomainVerificationIcon />,
//     2: <UploadFileIcon />,
//     3: <DoneIcon />,
//   };

//   return (
//     <ColorlibStepIconRoot
//       ownerState={{ completed, active }}
//       className={className}
//     >
//       {icons[String(props.icon)]}
//     </ColorlibStepIconRoot>
//   );
// }

// const steps = [
//   { key: "Verify OTP", icon: <DomainVerificationIcon /> },
//   { key: "Upload Before Pickup", icon: <UploadFileIcon /> },
//   { key: "Upload After Pickup", icon: <DoneIcon /> },
// ];

// export default function CustomizedSteppers() {
//   return (
//     <div className=" w-[100%] h-[120px] flex justify-center items-center">
//       <Stack sx={{ width: "100%" }} spacing={4}>
//         <Stepper
//           alternativeLabel
//           activeStep={2}
//           connector={<ColorlibConnector />}
//         >
//           {steps.map((label) => (
//             <Step key={label?.key}>
//               <StepLabel
//                 slots={{
//                   stepIcon: ColorlibStepIcon,
//                 }}
//               >
//                 {label.key}
//               </StepLabel>
//             </Step>
//           ))}
//         </Stepper>
//       </Stack>
//     </div>
//   );
// }


import * as React from "react";
import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";

/* ---------------- Connector ---------------- */

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        "linear-gradient(137deg,rgba(255, 43, 10, 1) 0%, rgba(255, 119, 0, 1) 35%, rgba(255, 208, 0, 1) 100%)",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        "linear-gradient(137deg,rgba(255, 43, 10, 1) 0%, rgba(255, 119, 0, 1) 35%, rgba(255, 208, 0, 1) 100%)",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor: "#eaeaf0",
    borderRadius: 1,
  },
}));

/* ---------------- Step Icon ---------------- */

const ColorlibStepIconRoot = styled("div")(({ ownerState }) => ({
  backgroundColor: "#ccc",
  zIndex: 1,
  color: "#fff",
  width: 50,
  height: 50,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  ...(ownerState.active && {
    backgroundImage:
      "linear-gradient(137deg,rgba(255, 43, 10, 1) 0%, rgba(255, 119, 0, 1) 35%, rgba(255, 208, 0, 1) 100%)",
    boxShadow: "0 4px 10px rgba(0,0,0,.25)",
  }),
  ...(ownerState.completed && {
    backgroundImage:
      "linear-gradient(137deg,rgba(255, 43, 10, 1) 0%, rgba(255, 119, 0, 1) 35%, rgba(255, 208, 0, 1) 100%)",
  }),
}));

function ColorlibStepIcon(props) {
  const { active, completed, className, iconComponent: Icon } = props;

  return (
    <ColorlibStepIconRoot
      ownerState={{ active, completed }}
      className={className}
    >
      {Icon && <Icon />}
    </ColorlibStepIconRoot>
  );
}

/* ---------------- Main Component ---------------- */

const StepperComponent = ({ steps = [], activeStep = 0 }) => {
  return (
    <div className="w-full h-[120px] flex justify-center items-center">
      <Stack sx={{ width: "100%" }} spacing={4}>
        <Stepper
          alternativeLabel
          activeStep={activeStep}
          connector={<ColorlibConnector />}
        >
          {steps.map((step, index) => (
            <Step key={step.label}>
              <StepLabel
                slots={{
                  stepIcon: (props) => (
                    <ColorlibStepIcon
                      {...props}
                      iconComponent={step.icon}
                    />
                  ),
                }}
              >
                {step.label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </Stack>
    </div>
  );
};

export default StepperComponent;
